import React from "react";
import { MainContainer } from "../styles/sharedStyles";
import Title from "../../components/title/Title";

import {
  Box,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  Paper,
} from "@mui/material";
import styled from "styled-components";
import { tokens } from "../../../theme";
import MensurationsEntryForm from "../../components/clientCoachUpdates/clientSection/mensurationsForm/MensurationsEntryForm";

const Section = styled.section`
  width: 100%;
  height: 100%;
  padding: 4rem 0rem;
`;

const AddMensurations = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const smScreen = useMediaQuery(theme.breakpoints.up("sm"));
  return (
    <MainContainer>
      <Title title="Ajout des mensurations" summary="A compléter" />
      <Section>
        <Grid item xs={12} md={6}>
          <Paper elevation={3} style={{ padding: "2rem" }}>
            <Typography
              variant="body1"
              color={colors.grey[100]}
              align="left"
              display="block"
            >
              A remplir
            </Typography>
          </Paper>
        </Grid>

        <Box m={2}>
          <Grid container justifyContent="center">
            <Grid item xs={12} sm={10} md={8} lg={6}>
              <MensurationsEntryForm />
            </Grid>
          </Grid>
        </Box>
      </Section>
    </MainContainer>
  );
};

export default AddMensurations;
